import * as yup from 'yup';

const empty = (s: string) => !s || !s.length;

const name = yup.string().min(2, 'Name is too short!').max(32, 'Name is too long!');
const requiredName = name.required('Name is required!');

const jobTitle = yup.string().min(2, 'Name is too short!').max(32, 'Name is too long!');
const requiredJobTitle = jobTitle.required('Name is required!');

const email = yup.string().email('Email is invalid!');
const requiredEmail = email.required('Email is required!');
const requiredEmailIfNoPhoneNumber = email.when('phone', {
  is: empty,
  then: requiredEmail,
  otherwise: yup.string(),
});

const phoneRegex = /^\++((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;
const phoneNumber = yup.string().matches(phoneRegex, 'Phone is not valid!');
const requiredPhoneNumber = phoneNumber.required('Phone is required!');
const requiredPhoneNumberIfNoEmail = phoneNumber.when('email', {
  is: empty,
  then: requiredPhoneNumber,
  otherwise: yup.string(),
});

const password = yup
  .string()
  .required('Password is required!')
  .min(6, 'Password is too short!')
  .matches(/[0-9]/, 'Password must contain at least one number!')
  .matches(/[a-zA-Z]/, 'Password must contain at least one letter!');

const otp = yup
  .string()
  .required('Code is required!')
  .matches(/^[0-9]{6}$/, 'Code is invalid!');

const Validators = {
  name,
  requiredName,
  email,
  requiredEmail,
  requiredEmailIfNoPhoneNumber,
  phoneNumber,
  requiredPhoneNumber,
  requiredPhoneNumberIfNoEmail,
  password,
  otp,
  jobTitle,
  requiredJobTitle,
};

export default Validators;
